import Box from "@mui/material/Box";
import { Route, Routes } from "react-router-dom";
import { Perm } from "../../permissions/permissions";
import { fillHeight } from "../../theme";
import RequirePermission from "../layout/RequirePermission";
import PlaylistsHome from "../media-network/PlaylistsHome";
import CrossSell from "../media-network/CrossSell";
import MediaLibrary from "../media-network/MediaLibrary";
import Advertisers from "../media-network/Advertisers";
import Tags from "../media-network/Tags";
import Reports from "../media-network/Reports";

// Router shell for the Media Network section, one route per nav sub-item.
//
// The shape mirrors the service: two FEATURES (Ad Banner, Cross-Sell) and the shared things all of them draw
// on (the media library, advertisers, tags). Ad Banner is the index route and carries its own tabs —
// playlists, schedules, playback configuration — because those three are genuinely about banner playback and
// mean nothing to the rest of the section.
//
// The library, advertisers and tags are siblings rather than tabs under a feature: Cross-Sell will use the
// same creatives, the same advertisers and the same tags, and burying them under Ad Banner would say
// otherwise. Advertisers was an Ad Banner tab until the reframe, which was the last thing still implying the
// attribution layer belonged to banners.
//
// Each route guards on its OWN permission rather than a section-wide one, so the guards live here beside the
// routes. Someone granted only the library gets the library and an Unauthorized page for the rest.
const MediaNetwork = () => (
    <Box sx={{ ...fillHeight, overflow: "hidden" }}>
        <Routes>
            <Route index element={
                <RequirePermission permission={Perm.mediaNetworkAdBanner}><PlaylistsHome /></RequirePermission>
            } />
            <Route path="cross-sell" element={
                <RequirePermission permission={Perm.mediaNetworkCrossSell}><CrossSell /></RequirePermission>
            } />
            <Route path="media-library" element={
                <RequirePermission permission={Perm.mediaNetworkMediaLibrary}><MediaLibrary /></RequirePermission>
            } />
            <Route path="advertisers" element={
                <RequirePermission permission={Perm.mediaNetworkAdvertisers}><Advertisers /></RequirePermission>
            } />
            <Route path="tags" element={
                <RequirePermission permission={Perm.mediaNetworkTags}><Tags /></RequirePermission>
            } />
            <Route path="reports" element={
                <RequirePermission permission={Perm.mediaNetworkReports}><Reports /></RequirePermission>
            } />
        </Routes>
    </Box>
);

export default MediaNetwork;
